import * as yup from 'yup';

import { STRINGS } from '@/constants/strings';

export type EnterEmailFormValues = {
  email: string;
};

const emailMessage = STRINGS.auth.enterEmail.validationEmail;

const emailForgotPasswordMessage = STRINGS.auth.forgotPassword.validationEmail;

export const enterEmailSchema = yup.object({
  email: yup
    .string()
    .matches(/[A-Z0-9a-z._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}/, emailMessage)
    .email(emailMessage)
    .required(emailMessage),
});

export const forgotPasswordSchema = yup.object({
  email: yup
    .string()
    .matches(/[A-Z0-9a-z._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}/, emailForgotPasswordMessage)
    .email(emailForgotPasswordMessage)
    .required(emailMessage),
});
